<template>
  <div class="row">
    <div class="col-12">
      <Heading>Benutzer</Heading>
      <div>
        <router-link class="btn btn-primary btn-sm px-5 mb-5" to="/admin/users/add/new"><i class="fas fa-plus pr-4"></i>Benutzer
          anlegen
        </router-link>
      </div>
      <SearchBar v-model="searchQuery"
                 placeholder="Suche nach Name / Username / Rolle"
      />
      <span class="text-primary d-inline-block mb-3">{{ users.length }} Treffer</span>

      <list :items="queryFilteredUsers" :sort-asc="sort.asc" :sort-key="sort.key">
        <template v-slot:header>
          <div class="row">
            <div class="col-3" @click="setSortProps('name')">
              Name
              <i v-if="sort.key === 'name' && sort.asc" class="fas fa-chevron-up"></i>
              <i v-else-if="sort.key === 'name' && !sort.asc" class="fas fa-chevron-down"></i>
            </div>
            <div class="col-3" @click="setSortProps('role')">
              Rolle
              <i v-if="sort.key === 'role' && sort.asc" class="fas fa-chevron-up"></i>
              <i v-else-if="sort.key === 'role' && !sort.asc" class="fas fa-chevron-down"></i>
            </div>
            <div class="col-5" @click="setSortProps('deleted')">
              Status
              <i v-if="sort.key === 'deleted' && sort.asc" class="fas fa-chevron-up"></i>
              <i v-else-if="sort.key === 'deleted' && !sort.asc" class="fas fa-chevron-down"></i>
            </div>
            <div class="col-1"></div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <!--					<pre>{{item}}</pre>-->
          <div class="row align-items-center py-1">
            <div class="col-3">{{ item.name || '-' }}<br>
              <span class="small">({{ item.username || '-' }})</span>
            </div>
            <div class="col-3">{{ item.role }}</div>
            <div class="col-5">
              <template v-if="item.active">
                <span class="text-primary">Aktiv</span>
              </template>
              <template v-else>
                <span class="text-danger">Inaktiv</span>
              </template>
            </div>
            <div class="col-1 text-right">
              <button class="btn" @click="$router.push('/admin/users/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapActions, mapState} from "vuex";

import Navigation from "../../components/admin/Navigation";
import List from "../../components/admin/List";
import SearchBar from "../../components/admin/SearchBar";
import Heading from "../../components/admin/Heading";
import BottleState from "../../components/admin/BottleState";

export default {
  name: "UserList",
  components: {BottleState, List, Navigation, Heading, SearchBar},
  data() {
    return {
      searchQuery: "",
      sort: {
        key: 'username',
        asc: true
      }
    }
  },
  mounted() {
    this.refreshUsers()
  },
  computed: {
    ...mapState({
      users: state => state.Api.Users.all
    }),
    queryRegex() {
      return this.searchQuery.toLocaleLowerCase().replace(' ', '.*')
    },
    queryFilteredUsers() {
      return this.users.filter(el => {

        let matchName = (el.name || "").match(this.queryRegex);
        let matchUsername = el.username.match(this.queryRegex);
        let matchRole = el.role.match(this.queryRegex);

        return (matchName && matchName.length > 0)
            || (matchUsername && matchUsername.length > 0)
            || (matchRole && matchRole.length > 0);
      })
    },
  },
  methods: {
    ...mapActions({
      refreshUsers: "Api/Users/all"
    }),
    setSortProps(key) {
      Vue.set(this.sort, 'key', key);
      Vue.set(this.sort, 'asc', !this.sort.asc);
    }
  },
}
</script>

<style scoped>

</style>
